export default {
  formId: 'createConfiguracionTurnosForm', //'checkoutForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre Configuracion*',
      requiredErrorMsg: 'El nombre es requerido.',
    },
    cargo: {
      name: 'cargo',
      label: 'Nombre cargo*',
      requiredErrorMsg: 'El cargo es requerido.',
    },
    fechaInicioTurno: {
      name: 'fechaInicioTurno',
      label: 'Fecha Inicio Turno*',
      requiredErrorMsg: 'La fecha inicio turno es requerida.',
    },
    TipoTurno: {
      name: 'TipoTurno',
      label: 'Tipo Turno*',
      requiredErrorMsg: 'El tipo turno es requerido.',
    },
    turnos: {
      name: 'turnos',
      label: 'Turnos*',
      requiredErrorMsg: 'Los turnos son requeridos.',
    },
    autoGenerarse: {
      name: 'autoGenerarse',
      label: 'Autogenerar Configuracion?*',
      requiredErrorMsg: 'El tipo turno es requerido.',
    },
    domingosyFestivos: {
      name: 'domingosyFestivos',
      label: 'Aplica Domingos y Festivos?*',
      requiredErrorMsg: 'El tipo turno es requerido.',
    },
    frecuencia: {
      name: 'frecuencia',
      label: 'Frecuencia Turnos*',
      requiredErrorMsg: 'La frecuencia turnos es requerida.',
    },
  },
};
